import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import "moment/locale/es"; // without this line it didn't work
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import AddIcon from "@material-ui/icons/Add";
import { Grid, Paper, Fab, Button } from "@material-ui/core";
import { EmpresaAfiliadoItem } from "./EmpresaAfiliadoItem";
import { fetchEmpresasPreafiliado } from "../../actions/empresasPreafiliado";
import { NuevaEmpresaPreAfiliado } from "./NuevaEmpresaPreafiliado";
import { CardAportEmpresas } from "./CardAportEmpresas";
import { ModalAportesPreafiliado } from "./ModalAportesPreafiliado";
import { fetchAportes } from "../../actions/aportes";
const useStyles = makeStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    background: "white",
  },
  container: {
    margin: 10,
    width: "90vw",
    padding: 20,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    // backgroundColor: '#90ee90'
  },
}));

export const FormularioEmpresaPreAfiliado = ({
  setHabilitado,
  afiliado,
  abrirModal,
  setAbrirModal,
  fromBandeja
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const activeId = useRef(afiliado?.id_afiliado);

  const { cargada, items: empresas } = useSelector((state) => state.empresasPreafiliado);
  const { afiliadoEncontrado: preinscripto } = useSelector(state => state.preinscripto)

  const [abrir, setAbrir] = useState(false);
  const [openAportes, setOpenAportes] = React.useState(false);

  const handleEmpresaInsertar = (e) => {
    e.preventDefault();
    setAbrir(true);
  };

  useEffect(() => {
    if (afiliado && afiliado?.id_afiliado !== activeId.current) {
      dispatch(fetchEmpresasPreafiliado(afiliado?.id_afiliado));
      activeId.current = afiliado.id_afiliado;
    }
  }, [afiliado, dispatch]);

  useEffect(() => {
    if (empresas.length === 0) {
      setHabilitado(true);
    } else {
      setHabilitado(false);
    }
  }, [empresas, setHabilitado]);

  useEffect(() => {
    if(preinscripto){
      dispatch(fetchAportes(preinscripto.cuil))
    }
    // eslint-disable-next-line
  }, [])

  return (
    <>
      <NuevaEmpresaPreAfiliado abrirModal={abrir} setAbrirModal={setAbrir} />
      <ModalAportesPreafiliado open={openAportes} handleClose={() => setOpenAportes(false)} />

      <Paper elevation={3} className={classes.container}>
        <Grid
          container
          direction="row"
          justify="space-between"
          alignItems="center"
        >
          <Grid item xs={12}>
            <Typography variant="h5" component="h2">
              Empresas Pre Afiliacion
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Grid
              container
              direction="row"
              justify="space-between"
              alignItems="center"
            >
              <Fab
                className={classes.buttonOk}
                color="secondary"
                aria-label="add"
                size="medium"
                onClick={handleEmpresaInsertar}
              >
                <AddIcon />
              </Fab>
              <Button
                variant="contained"
                color="secondary"
                style={{ marginTop: 15, marginBottom: 10, float: 'right' }}
                onClick={() => setOpenAportes(true)}
              >
                Ver aportes
              </Button>
            </Grid>
          </Grid>
          <CardAportEmpresas />
          <Grid item container justify="center">
            {cargada &&
              empresas.length > 0 &&
              empresas.map((item) => (
                <EmpresaAfiliadoItem
                  key={item.idEmpresasAfiliados}
                  item={item}
                  from="PREAFILIACIONES"
                  fromBandeja={fromBandeja}
                />
              ))}
          </Grid>
        </Grid>{" "}
      </Paper>
    </>
  );
};
